import { useState } from 'react';
import useCallApiAndLoad from '../../../hooks/useCallApiAndLoad';
import useAuth from '../../../hooks/useAuth';
import { useToast } from '../../../components/toast/ToastProvider';
import { fetchResponseAdapter } from '../../../adapters/fetchAdapter';
import { updatePropertyIsVerifiedEndpoint } from '../services/propertyService';

// Verificar/quitar verificación sin cargar la propiedad otra vez: la pantalla
// que lo usa ya trae `is_validated_by_proper`. Mismo endpoint que useAdminProperty.
const useVerifyProperty = (propertyId: string, initialValue: boolean) => {
  const { callEndpoint } = useCallApiAndLoad();
  const { getAuthToken } = useAuth();
  const token = getAuthToken();
  const toast = useToast();
  const [isVerified, setIsVerified] = useState(initialValue);
  const [isSaving, setIsSaving] = useState(false);

  // Solo se actualiza el estado local si el API responde 200.
  const changeVerified = async (nextValue: boolean) => {
    setIsSaving(true);
    try {
      const { status, data } = await callEndpoint(
        updatePropertyIsVerifiedEndpoint(
          { is_validated_by_proper: nextValue },
          propertyId,
          token,
        ),
      );
      if (status !== 200) {
        console.error(fetchResponseAdapter(data).message);
        toast.error('No se pudo cambiar la verificación. Intenta de nuevo.');
        return false;
      }
      setIsVerified(nextValue);
      toast.success(
        nextValue
          ? 'Propiedad verificada. Ya se muestra el check en la web.'
          : 'Se quitó la verificación de la propiedad.',
      );
      return true;
    } catch (e) {
      console.error(e);
      toast.error('No se pudo cambiar la verificación. Intenta de nuevo.');
      return false;
    } finally {
      setIsSaving(false);
    }
  };

  return { isVerified, isSaving, changeVerified, setIsVerified };
};

export default useVerifyProperty;
